export const SENT_MEETINGS_TAB = 'sent',
    REQUESTED_MEETINGS_TAB = 'requests',
    CONFIRMED_MEETINGS_TAB = 'confirmed',
    ALL_MEETINGS_TAB = 'all';

export const VALID_TABS = [SENT_MEETINGS_TAB, REQUESTED_MEETINGS_TAB, CONFIRMED_MEETINGS_TAB, ALL_MEETINGS_TAB];
